import React, { useContext, useEffect, useMemo } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link } from 'react-router-dom';

import './BusFareSummary.css';

import {
  BusFareDepartContext,
  BusFareReturnContext,
  ChildAmountContext,
  CurrencyContext,
  CurrentCurrencyContext,
  SelectSeatDepartContext,
  SelectSeatReturnContext,
  TotalBusFareContext,
} from '../UserContext';
import {
  checkIsSgdTrip,
  getMonetaryUnitBasedOnCurrency,
  checkIsReschedule,
  getAMorPMonTime,
  getSubPlaceShortName,
  getMonetaryUnitText,
  sessionStorageSetItem,
  sessionStorageGetItem,
} from './Function';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';

export const BusFareSummary = ({
  include,
  depart_unique_name,
  destination_unique_name,
  depart,
  selectedSeat = [],
  destination,
  depart_date,
  return_date,
  passenger,
  change_trip,
  depart_info,
  return_info,
  shuttleTrip,
}) => {
  let Fare_total = 0;
  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext
  );

  const checkReschedule = checkIsReschedule();
  const monetary_unit = getMonetaryUnitText(currentCurrency);
  const { childAmount, setChildAmount } = useContext(ChildAmountContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const request_id = searchParams.get('request_id') ?? '';

  const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

  // const departName = useMemo(() => {
  // 	const name = getSubPlaceShortName(depart);
  // 	return
  // }, [depart]);

  // const destinationName = useMemo(() => {
  // 	const name = getSubPlaceShortName(destination);

  // 	return name.length > 14 ? `${name.substring(0, 14)}...` : name;
  // }, [destination]);

  // const child_discount = 2;
  if (checkReschedule == true) {
    if (sessionStorageGetItem('Origin_data') != null) {
      const reschedule_origin_data = JSON.parse(
        sessionStorageGetItem('Origin_data')
      );
      depart_date = depart_info.departure_time.split(' ')[0];
      if (return_info != null) {
        return_date = return_info.departure_time.split(' ')[0];
      }
      passenger = reschedule_origin_data.Passenger;
    }
  }
  // const [child_discount,setChildDiscount] = useState(0);
  // console.log(depart_info);
  // console.log(depart_info.fare);
  // console.log(depart_info.child_fare);
  // console.log(childAmount);
  let converted_return_date = null;
  const { selectedDepartSeat, setDepartSeat } = useContext(
    SelectSeatDepartContext
  );
  const { selectedReturnSeat, setReturnSeat } = useContext(
    SelectSeatReturnContext
  );
  const { BusFareDepart, setBusFareDepart } = useContext(BusFareDepartContext);
  const { BusFareReturn, setBusFareReturn } = useContext(BusFareReturnContext);
  const { TotalBusFare, setTotalBusFare } = useContext(TotalBusFareContext);

  const departDataMultiModal = JSON.parse(
    sessionStorageGetItem('departDataMultiModal')
  );

  const shuttleFee = Number(
    (departDataMultiModal
      ? currentCurrency === 'MYR'
        ? departDataMultiModal?.fare
        : departDataMultiModal?.adultPriceInSgd
      : 0
    ).toFixed(2)
  );

  // // console.log('selected:'+ selectedSeat[0].DisplayCode);
  // console.log('length: ' + selectedSeat.length);
  function selectedSeatFunction() {
    if (selectedSeat.length === 0) {
      return 'Not Selected';
    } else if (selectedSeat.length === 1) {
      return selectedSeat[0].DisplayCode;
    } else {
      var array = [];
      for (var i = 0; i < selectedSeat.length; ++i) {
        array.push(selectedSeat[i].DisplayCode);
      }
      var stringSelected = array.join(',');
      // console.log(array)
      return stringSelected;
    }
  }

  // function updateBusFare(fare) {
  //     setTotalBusFare(TotalBusFare=>[...TotalBusFare,fare]);
  // }
  if (return_info != null) {
    const selected_return_date = return_info.departure_time.split(' ')[0];
    // console.log(selected_return_date)
    converted_return_date = new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      weekday: 'long',
    }).format(Date.parse(selected_return_date));
    // console.log(converted_return_date);
  }

  const converted_depart_date = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    weekday: 'long',
  }).format(Date.parse(depart_date));

  if (include == 'depart') {
    const selected_depart_time = getAMorPMonTime(
      depart_info.departure_time.split(' ')[1]
    );
    let params = `depart=${depart_unique_name}&destination=${destination_unique_name}&depart_date=${depart_date}&return_date=${return_date}&passenger=${passenger}&request_id=${request_id}`;
    let href = `${change_trip}?${params}`;
    if (checkReschedule) {
      href = change_trip;
    }

    const departFare =
      currentCurrency === 'MYR'
        ? depart_info.fare
        : depart_info.adultPriceInSgd || 0;

    const childFare =
      currentCurrency === 'MYR'
        ? depart_info.child_fare
        : depart_info.childPriceInSgd || 0;

    // const child_discount = 2.2849.toFixed(2);
    let child_discount = (departFare - childFare).toFixed(2);
    // console.log(child_discount)
    function getDepartFare(fare) {
      const myrFare =
        depart_info.fare * selectedSeat.length - child_discount * childAmount;

      const sgdFare =
        (depart_info.adultPriceInSgd || 0) * selectedSeat.length -
        child_discount * childAmount;

      // sessionStorageSetItem('departBusFare', {
      // 	fare: myrFare,
      // 	sgdFare: sgdFare,
      // });

      sessionStorageSetItem(
        'departBusFare',
        JSON.stringify({
          fare: myrFare,
          sgdFare: sgdFare,
        })
      );

      // console.log(`[departBusFare]myrFare=${myrFare}`);
      // console.log(`[departBusFare]sgdFare=${sgdFare}`);

      if (checkReschedule) {
        return 0;
      } else {
        return fare === 0 ? 0 : (fare + shuttleFee).toFixed(2);
      }
    }

    // console.log(depart_info);
    Fare_total =
      departFare * selectedSeat.length - Number(child_discount) * childAmount;

    if (checkIsSgdTrip()) {
      child_discount = (departFare - childFare).toFixed(2);

      Fare_total =
        departFare * selectedSeat.length - Number(child_discount) * childAmount;
    }
    // console.log('money:'+Fare_total);
    // console.log('bus fare:'+TotalBusFare);
    return (
      <>
        <Row>
          <Col sm={12}>
            <div className='arrow-container'>
              <div className='text-in-line'>
                {shuttleTrip
                  ? shuttleTrip.departureTo.length > 14
                    ? `${shuttleTrip.departureTo.substring(0, 14)}...`
                    : shuttleTrip.departureTo
                  : depart_info.pick_up.length > 14
                  ? `${depart_info.pick_up.substring(0, 14)}...`
                  : depart_info.pick_up}
              </div>
              <div className='arrow-right'></div>
            </div>

            <div className='arrow-container ms-left'>
              <div className='text-in-line'>
                {depart_info.drop_off.length > 14
                  ? `${depart_info.drop_off.substring(0, 14)}...`
                  : depart_info.drop_off}
              </div>
              <div className='arrow-right-front'></div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <table width={'100%'}>
              <tr>
                <td>
                  <h6>Date Selected</h6>
                </td>
                <td>
                  <h5>{moment(converted_depart_date).format('DD/MM/YYYY')}</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Departure Time</h6>
                </td>
                <td>
                  <h5>{selected_depart_time}</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Seat Selected</h6>
                </td>
                <td>
                  <h5>{selectedSeatFunction()}</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Fare</h6>
                </td>
                <td>
                  <h5>
                    {monetary_unit} {getDepartFare(Fare_total)}
                  </h5>
                </td>
              </tr>

              {depart_info?.ShuttleBusTripKey?.length > 0 && (
                <tr>
                  <td>
                    <h6>Stop</h6>
                  </td>
                  <td>
                    <h5>
                      <>
                        Multi-stop shuttle bus transfer to Harbour Front
                        <span className='oval_star ms-1'>★</span>
                      </>
                    </h5>
                  </td>
                </tr>
              )}
            </table>
            <Link
              to={href}
              onClick={() => {
                setDepartSeat([]);
                setReturnSeat([]);
              }}
            >
              Change Trip
            </Link>
          </Col>
        </Row>
      </>
    );
  }
  if (return_info != null) {
    const selected_return_time = getAMorPMonTime(
      return_info.departure_time.split(' ')[1]
    );
    // let str_depart_info = JSON.stringify(depart_info);
    let params = `depart=${depart_unique_name}&destination=${destination_unique_name}&depart_date=${depart_date}&return_date=${return_date}&passenger=${passenger}&depart_info=${depart_info}&request_id=${request_id}`;
    let href = `${change_trip}?${params}`;
    if (checkReschedule) {
      href = change_trip;
    }

    const departFare =
      currentCurrency === 'MYR'
        ? return_info.fare
        : return_info.adultPriceInSgd || 0;

    const childFare =
      currentCurrency === 'MYR'
        ? return_info.child_fare
        : return_info.childPriceInSgd || 0;
    // const child_discount = 8;
    let child_discount = (departFare - childFare).toFixed(2);

    function getReturnFare(fare) {
      const myrFare =
        return_info.fare * selectedSeat.length - child_discount * childAmount;

      const sgdFare =
        (return_info.adultPriceInSgd || 0) * selectedSeat.length -
        child_discount * childAmount;

      sessionStorageSetItem(
        'returnBusFare',
        JSON.stringify({
          fare: myrFare,
          sgdFare: sgdFare,
        })
      );

      // console.log(`[returnBusFare]myrFare=${myrFare}`);
      // console.log(`[returnBusFare]sgdFare=${sgdFare}`);

      if (checkReschedule) {
        return 0;
      } else {
        return (Number.isNaN(fare) ? 0 : Number(fare)).toFixed(2);
      }
    }

    Fare_total =
      departFare * selectedSeat.length - Number(child_discount) * childAmount;

    if (checkIsSgdTrip()) {
      child_discount = (departFare - childFare).toFixed(2);
      Fare_total =
        departFare * selectedSeat.length - Number(child_discount) * childAmount;
    }
    return (
      <>
        <Row>
          <Col sm={12}>
            <div className='arrow-container'>
              <div className='text-in-line'>
                {/* {getSubPlaceShortName(destination)} */}
                {/* {destinationName} */}
                {return_info.pick_up.length > 14
                  ? `${return_info.pick_up.substring(0, 14)}...`
                  : return_info.pick_up}
              </div>
              <div className='arrow-right'></div>
            </div>

            <div className='arrow-container ms-left'>
              <div className='text-in-line'>
                {/* {getSubPlaceShortName(depart)} */}
                {/* {departName} */}
                {return_info.drop_off.length > 14
                  ? `${return_info.drop_off.substring(0, 14)}...`
                  : return_info.drop_off}
              </div>
              <div className='arrow-right-front'></div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <table width={'100%'}>
              <tr>
                <td>
                  <h6>Date Selected</h6>
                </td>
                <td>
                  <h5>{moment(converted_return_date).format('DD/MM/YYYY')}</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Departure Time</h6>
                </td>
                <td>
                  <h5>{selected_return_time}</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Seat Selected</h6>
                </td>
                <td>
                  <h5>{selectedSeatFunction()}</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>Fare</h6>
                </td>
                <td>
                  <h5>
                    {monetary_unit} {getReturnFare(Fare_total)}
                  </h5>
                </td>
              </tr>
            </table>
            <Link
              to={href}
              onClick={() => {
                setDepartSeat([]);
                setReturnSeat([]);
              }}
            >
              Change Trip
            </Link>
          </Col>
        </Row>
      </>
    );
  }
};
